module.exports = __webpack_public_path__ + "img/warning.321c9d21.svg";